import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { normalizeInput } from '../../../pages/Manage/ManageUser/ManageUserUtil';
import MobileNumber from '../../../utils/MobileNumber/MobileNumber';
import { getFormatedRolesforDrivers } from "../../../web/pages/userProfile/userProfileUtil";
import React, { useState } from "react";
import { Persona } from "../persona/persona";

import "./driverCard.scss";
import { NEVER_LOGGED_IN, RE_SEND_INVITE_BUTTON_NAME, RE_SEND_INVITE_FAILURE_MESSAGE, RE_SEND_INVITE_MODAL_MESSAGE, RE_SEND_INVITE_MODAL_TITLE, RE_SEND_INVITE_SUCCESS_MESSAGE } from "app/utils/constants";
import { isDispatcherRole } from "../../../utils/roleUtil/RoleUtil";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { dayjs } from "../../../utils/Date/DateUtil";
import { IONICWrapper, isMobile, payloadCreationForReSendInviteNotification } from "../../../utils/common";
import { ToastMessage } from "../../../utils/ToastMessage";
import { useDispatch } from "react-redux";
import { reSendInviteForAssignDriver } from "../../../actions/carrierAssign/action";

export interface IDriverCardProps {
  driverData: any;
  index: number;
  selectedIndex: number;
  onSelect: (driverDetails: any, currentIndex: number) => void;
  onReSendInvite?:() => void;
}

export const DriverCardWeb: React.FunctionComponent<IDriverCardProps> = (
  props: IDriverCardProps
) => {
  const { driverData = {} } = props;
  const [reSendInviteModalOpen,setReSendInviteModalOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loginStatusValue = IONICWrapper?.details?.keys?.configuration?.LoginStatusValue || NEVER_LOGGED_IN;
    const onReSendInvite = (event : any)=>
    {   event?.stopPropagation();
        setReSendInviteModalOpen(true)
    }
    const reSendInviteModalProps = {
        isModalOpen:  reSendInviteModalOpen,
        title: IONICWrapper?.details?.keys?.configuration?.ResendInviteModalTitle || RE_SEND_INVITE_MODAL_TITLE,
        message :IONICWrapper?.details?.keys?.configuration?.ResendInviteModalMessage || RE_SEND_INVITE_MODAL_MESSAGE,
        aditionalCssClass : "",
        size: "extra_medium_height",
        contentScroll: "deny",
        backdropDismiss:false,
        buttons: [
          {
            title: IONICWrapper?.details?.keys?.configuration?.ResendInviteButtonName || RE_SEND_INVITE_BUTTON_NAME,
            type: "primary-cta-btn-web",
            onClick: () => {
                setReSendInviteModalOpen(false)
                let payload  = payloadCreationForReSendInviteNotification({
                    upn: driverData?.upn,
                    email: driverData?.email,
                    phoneNumber: driverData?.mobileNumber,
                    carrierName: driverData?.companyName,
                  });
              
                  const callback = (responseType: string, data: any) => {
                    setReSendInviteModalOpen(false);
                    if (responseType === "success") {
                      if (data?.success === "true") {
                        isMobile
                          ? ToastMessage.show(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteSuccessMessage ||
                                RE_SEND_INVITE_SUCCESS_MESSAGE
                            )
                          : ToastMessage.showWeb(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteSuccessMessage ||
                                RE_SEND_INVITE_SUCCESS_MESSAGE
                            );
                      } else if (data?.success === "false") {
                        isMobile
                          ? ToastMessage.show(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteFailureMessage ||
                                RE_SEND_INVITE_FAILURE_MESSAGE
                            )
                          : ToastMessage.showWeb(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteFailureMessage ||
                                RE_SEND_INVITE_FAILURE_MESSAGE
                            );
                      }
                    }
                  };
                  dispatch(
                    reSendInviteForAssignDriver({
                      query: payload,
                      callback
                    })
                  );
            
           }
      }
        ]
      };

  return (
    <React.Fragment>
      <CustomModalWeb {...reSendInviteModalProps}/>
      <IonGrid
        className={`driver-card-grid ${props.index == props.selectedIndex  ? "selected" : ""
          }`}
        onClick={() => {
          props.onSelect(driverData, props.index);
        }}
      >
        <IonRow>
          <IonCol size="2" className="card-price-col driver-card-persona-col">
            <span className="driver-persona">
              <Persona
                name={`${driverData.firstName} ${driverData.lastName}`}
                showName={false}
                manageUsersFlag={false}
              />
            </span>
          </IonCol>
          <IonCol size="5">
            <div className="middlepart">
              <div className="driver-details-row">
                <span className="driver-name">{`${driverData.firstName} ${driverData.lastName}`}</span>
              </div>
              <div className="driver-role-manage">
                <span>{getFormatedRolesforDrivers(driverData)}</span>
              </div>
            </div>
          </IonCol>
          <IonCol size="5" className="driver-other-dtls-col">
            <div className="driver-details-row">
              <span className="driver-details">Tractor No</span>{" "}
              <span className="driver-data">{driverData.tractorNumber}</span>
            </div>
            <div className="driver-details-row">
              <span className="driver-details">Mobile No</span>{" "}
              <span className="driver-data">{driverData && driverData.mobileNumber &&
                <MobileNumber
                  mobileNumber={normalizeInput(driverData.mobileNumber)}
                  mobileReadOnly={true}
                  name="mobileNumber"
                  placeholder={''}
                  label=''
                  nonEditableField={true}
                  countryCodefromMember={driverData.mobileNumber.slice(0, -10)}
                />
              }</span>
            </div>
            {isDispatcherRole()  && (driverData?.userLastLogin === null ||driverData?.userLastLogin === undefined || driverData?.userLastLogin === "") ? <><div className="driver-details-row">
              <span className="driver-details">Login Status</span>{" "}
              <span className="driver-data loginStatus">{loginStatusValue}</span>
              </div>
              {(driverData?.upn === null || driverData?.userPrincipalName === null) && <div className="driver-details-row">
              <span className='driver-details resend-invite'onClick={(e) => onReSendInvite(e)}>Re-Send Invite</span>
            </div>}</>:
            <div className="driver-details-row">
            <span className="driver-details">Last Login</span>{" "}
            <span className="driver-data">{dayjs(driverData?.userLastLogin).format("MMM DD, YYYY")}</span>
          </div>}
          </IonCol>
        </IonRow>
      </IonGrid>
    </React.Fragment>
  );
};
